module.exports = __webpack_public_path__ + "static/bitpay_config_generator-cda9b6bc1f844c21647779740265c11d.png";